import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, Box, Typography, Drawer } from '@mui/material';
import { useModals } from '@mattjennings/react-modal-stack';
import Iconify from '@/components/Iconify';
import TicketCountSelect from '@/templates/plus/sections/tickets/TicketCountSelect';
import useMobile from '@/hooks/useMobile';

const ConfirmQuantityDialog = ({
  open,
  onConfirm = () => {},
  onCancel = () => {},
  blockClose = false,
  quantity,
}) => {
  const { t } = useTranslation();
  const { closeModal } = useModals();
  const { isMobile } = useMobile();
  const [numberOfTicketsSelected, setNumberOfTicketsSelected] = useState(
    quantity - 1,
  );

  if (!open) {
    return null;
  }

  const handleClose = () => {
    if (!blockClose) {
      closeModal();
    }
  };

  const handleAcept = () => {
    closeModal();
    onConfirm(numberOfTicketsSelected);
  };

  const handleCancel = () => {
    closeModal();
    onCancel();
  };

  const body = (
    <Box
      sx={{
        '& .MuiDialogActions-root': {
          paddingTop: 0,
        },
      }}
    >
      <Box
        sx={{
          mr: 2,
          mt: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Box
          sx={{
            'width': '20px',
            'height': '20px',
            'display': 'flex',
            'alignItems': 'center',
            'justifyContent': 'center',
            '&:hover': {
              cursor: 'pointer',
            },
          }}
          onClick={handleClose}
        >
          <Iconify
            width={16}
            height={16}
            icon={'material-symbols:close'}
            sx={{
              color: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[800]
                  : theme.palette.grey[200],
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          width: '100%',
          paddingLeft: '24px',
          paddingRight: '24px',
        }}
      >
        <Typography
          paragraph
          sx={{
            margin: 0,
            padding: 0,
            color: (theme) => theme.palette.grey[900],
            fontSize: '20px',
            fontWeight: 600,
          }}
          variant="body2"
        >
          {t('checkout.global.ticketsFly')}
        </Typography>
      </Box>
      <Box
        sx={{
          mt: 2,
          width: '100%',
          paddingLeft: '24px',
          paddingRight: '24px',
        }}
      >
        <Typography
          paragraph
          sx={{
            margin: 0,
            padding: 0,
            color: (theme) => theme.palette.grey[700],
            mb: 4,
          }}
          variant="body2"
        >
          {t('checkout.global.noAvailability', { count: quantity })}
        </Typography>
      </Box>

      <Box
        sx={{
          width: '100%',
          paddingLeft: '24px',
          paddingRight: '24px',
          display: 'flex',
          justifyItems: 'center',
        }}
      >
        <TicketCountSelect
          sx={{
            minWidth: '180px',
            mr: 2,
          }}
          max={quantity - 1}
          value={numberOfTicketsSelected}
          onChange={(value) => {
            setNumberOfTicketsSelected(value);
          }}
        />
        <Button variant="contained" onClick={handleAcept} autoFocus fullWidth>
          {t('checkout.buttons.retry')}
        </Button>
      </Box>
      <Box
        sx={{
          width: '100%',
          paddingLeft: '24px',
          paddingRight: '24px',
          mb: 1,
          mt: 1,
        }}
      >
        <Button
          variant="text"
          onClick={handleCancel}
          autoFocus
          fullWidth
          sx={{
            color: (theme) => theme.palette.grey[600],
            textDecoration: 'underline',
          }}
        >
          {t('checkout.buttons.searchOtherZone')}
        </Button>
      </Box>
    </Box>
  );

  return (
    <>
      {isMobile ? (
        <Drawer open={open} onClose={handleClose} anchor="bottom">
          {body}
        </Drawer>
      ) : (
        <Dialog open={open} onClose={handleClose} maxWidth="xs">
          {body}
        </Dialog>
      )}
    </>
  );
};

export default ConfirmQuantityDialog;
